import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose, get } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

// Components
import Payment from '../../components/Payment';
import Loader from '../../components/Loader';
import NotFound from '../notFound/NotFound';

// Helpers
import showToaster from '../../helpers/showToaster';

import getPaymentDataQuery from './getPaymentData.graphql';
import { withQuery } from '../../hoc/withGraphql';

import s from './Payment.css';
class PaymentContainer extends React.Component {
  static propTypes = {
    reservationId: PropTypes.number.isRequired,
    paymentData: PropTypes.shape({
      loading: PropTypes.bool,
      getPaymentData: PropTypes.object
    })
  };

  componentDidMount() {
    // Check for error parameter in URL and show toast
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const error = urlParams.get('error');
      if (error === 'payment_failed') {
        showToaster({ 
          messageId: 'paymentFailedError', 
          toasterType: 'error' 
        });
        // Clean up URL by removing the error parameter
        window.history.replaceState({}, '', window.location.pathname);
      }
    }
  }

  render() {
    const { paymentData: { loading, getPaymentData } } = this.props;

    if (!loading && !getPaymentData) {
      return <NotFound />
    }

    return (
      <div className={s.root}>
        <div className={s.container}>
          {
            loading && <Loader type={"text"} />
          }
          {
            !loading && <Payment data={getPaymentData} />
          }
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  withQuery(getPaymentDataQuery,
    {
      name: 'paymentData',
      options: (props) => ({
        variables: {
          reservationId: props.reservationId,
        },
        ssr: false
      })
    }
  ),
)(PaymentContainer);
